// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator tasks`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import users from 'modules/core/store/collections/users'

import contractVersionsPayrollPolicies from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import employees from 'modules/employees/store/collections/employees'
import payrollPolicies from 'modules/payroll_bundle/store/collections/policies'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [contractVersionsPayrollPolicies, {}] /* Referenced by 14 cases in this module */,
    [employees, {}] /* Referenced by 4 cases in this module */,
    [features, {}] /* Referenced by 7 cases in this module */,
    [legalEntities, {}] /* Referenced by 13 cases in this module */,
    [payrollPolicies, {}] /* Referenced by 16 cases in this module */,
    [users, {}] /* Referenced by 6 cases in this module */,
  ] /* Generated file 👉 artifacts/tasks-module-employees.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
